import {
  ResourceService,
} from '@/internal';

export default class LogItemService extends ResourceService {
  constructor() {
    super();
    this.baseUrl = 'log-item';
  }
}
